import React from 'react';
import { GenericEmptyStateSVG } from 's2s-svg-icons';
import Button from 's2s-button';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import { getIntlText } from '../js/utilities';

const ContactListZeroState = styled.div`
  align-items: center;
  background-color: ${colorGrid.gray0};
  display: flex;
  height : calc(100vh - 96px); //50px height search container and 46px height header area
  flex-direction: column;
`;

//using hex value for color because the brand colors in colorgrid changed between versions at some point
const ContactListZeroStateText = styled.div`
  color: ${colorGrid.brand5};
  font-size: 18px;
  line-height: 150%;
  padding-left: 40px;
  padding-right: 40px;
  text-align: center;
`;

const ContactListZeroStateDesc = styled.div`
  color: ${colorGrid.gray5};
  font-size: 16px;
  line-height: 1.5;
  padding-top: 10px;
`;

const ContactListZeroStateButtonContainer = styled.div`
  padding-top: 20px;
`;

const zeroStateSVGStyle = {
  fill: colorGrid.brand8,
  height: '219px',
  paddingBottom: '20px',
  paddingTop: '65px',
  width: '251px'
};

const ListZeroState = (props) => {

  return (
    <ContactListZeroState className="zeroState">
      <GenericEmptyStateSVG className="dsvg" svgStyle={zeroStateSVGStyle} />
      <ContactListZeroStateText className="zeroStateText">
        {getIntlText(props.intl, 'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE', 'No Contact Information')}
      </ContactListZeroStateText>
      <ContactListZeroStateDesc className="zeroStateDescription">
      {getIntlText(props.intl, 'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION', 'Add a number to get started')}
      </ContactListZeroStateDesc>
      <ContactListZeroStateButtonContainer className="zeroStateButtonContainer">
        <Button
          buttonLabel={getIntlText(props.intl, 'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL', 'Add a number')}
          buttonType="primaryGreen"
          cbClick={props.cbButtonClick}
          ariaLabel={getIntlText(props.intl, 'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-ARIA-LABEL', 'Add a number')}
        />
      </ContactListZeroStateButtonContainer>
    </ContactListZeroState>
  );
};

ListZeroState.propTypes = {
  cbButtonClick: PropTypes.func,
  intl : PropTypes.object
};

ListZeroState.defaultProps = {
  cbButtonClick: () => { console.log('cbButtonClick is not defined'); },
};

export default ListZeroState;
